import fetch from '../utils/fetch';

/**
 *获取选择盲盒活动信息
 * @export
 * @param {*} activityId
 * @returns
 */
export function getBlindBoxActivity(activityId) {
  const query = activityId ? `?activityId=${activityId}` : '';
  return fetch.get(`/marketing/api/blindBoxActivity/getForApp${query}`);
}

/**
 *选择盲盒
 * @param {} params
 * @returns
 */
export function memberBlindBoxChoose(params) {
  return fetch.post(`/marketing/api/memberBlindBox/choose`, params);
}

/**
 *获取盲盒信息
 * @param {*} activityId
 * @returns
 */
export function getMemberBlindBox(activityId) {
  return fetch.get(`/marketing/api/memberBlindBox/get?activityId=${activityId}`);
}

/**
 *获取任务列表
 * @param {*} params
 * @returns
 */
 export function getTaskList(activityId, izDone) {
  return fetch.get(`/marketing/api/memberEquityTask/getTaskList?activityId=${activityId}&izDone=${izDone}`);
}

/**
 *获取最近完成的任务
 * @param {*} params
 * @returns
 */
 export function listLatestDoneTask(activityId) {
  return fetch.get(`/marketing/api/memberEquityTask/listLatestDoneTaskForApp?activityId=${activityId}`);
}

/**
 *拆盲盒
 * @param {*} params
 * @returns
 */
export function openemberBlindBox(params) {
  return fetch.post(`/marketing/api/memberBlindBox/open`, params);
}

/**
 *解锁专属权益
 * @param {*} params
 * @returns
 */
export function unlockBlindBoxRights(params) {
  return fetch.post(`/marketing/api/memberBlindBox/unlockBlindBoxRights`, params);
}

// 提交用户做任务进展（开始做任务）
export function submitMemberTaskProgress(params) {
  return fetch.post(`/marketing/api/memberEquityTask/submitMemberTaskProgress`, params);
}

// 提交用户完成任务
export function completeTask(params) {
  return fetch.post(`/marketing/api/memberEquityTask/completeTask`, params);
}
